module.exports = __webpack_public_path__ + "img/arrow-left-s-fill.ee297c99.svg";